<template>
	<!-- 废弃 -->
	<div class="page-add page">
		<div class="searchBox" style="height: 126px;">
			<el-form>
				<el-row>
					<el-col :span="5" >
						<el-form-item label="单号 :" :label-width="'80px'">
							{{detail.inOrderNo}}
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="入库员 :" :label-width="'80px'">
							{{detail.approveUserName}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="入库日期 :" :label-width="'85px'">
							{{this.$public.FTime(detail.inDate)}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="入库类型 :" :label-width="'85px'">
							{{detail.inOrderType&&detail.inOrderType.name}}
						</el-form-item>
					</el-col>
					<el-col :span="1" :offset="3">
						<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5" >
						<el-form-item label="来源门店 :" :label-width="'85px'">
							{{detail.otherShopName}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="备注 :" :label-width="'80px'">
							{{detail.remark}}
						</el-form-item>
					</el-col>
					<el-col :span="5" v-if="detail.inOrderType.id==3">
						<el-form-item label="状态 :" :label-width="'80px'">
							<span v-if="detail.acceptStatus==0">未验收</span>
							<span v-else-if="detail.acceptStatus==1">部分验收</span>
							<span v-if="detail.acceptStatus==2">验收完成</span>
							<span v-if="detail.approveStatus.id==2"> 且审批完成</span>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div style="background-color: #fff;margin-top:20px;padding:20px 30px;min-height: 500px;">
			<el-table
				border
				:data="tableData"
				style="width: 100%; margin-top: 10px"
				:header-cell-style="{color: '#000000',background: '#f5f5f5',fontWeight: '700',}"
				ref="table"
				row-class-name="row-expand-cove"
			>
				<el-table-column label="名称" prop="goodsName">
				</el-table-column>
				<el-table-column label="规格">
					<template slot-scope="scope">
						<span>{{ scope.row.skuValue }}</span>
					</template>
				</el-table-column>
				<el-table-column label="单位">
					<template slot-scope="scope">
						<span>{{ scope.row.unit }}</span>
					</template>
				</el-table-column>
				<el-table-column label="数量">
					<template slot-scope="scope">
						{{scope.row.goodsItem.length}}
					</template>
				</el-table-column>
				<el-table-column label="状态" v-if="detail.inOrderType.id==3">
					<template slot-scope="scope">
					<span v-if="scope.row.count==scope.row.acceptCount">
						<span style="color:#13CE66">•</span>
						已验收 {{scope.row.acceptCount}} / {{scope.row.count}}
					</span>
					<span v-if="scope.row.count>scope.row.acceptCount&&scope.row.acceptCount!=0">
						<span style="color:#e6a23c">•</span>
						部分验收 {{scope.row.acceptCount}} / {{scope.row.count}}
					</span>
					<span v-if="scope.row.acceptCount==0">
						<span style="color:#e6a23c">•</span>
						未验收 {{scope.row.acceptCount}} / {{scope.row.count}}
					</span>
					</template>
				</el-table-column>
				<el-table-column type="expand" width="1">
					<template slot-scope="scope">
						<el-table v-show="false" :data="scope.row.goodsItem">
							<el-table-column prop="count">
							</el-table-column>
						</el-table>
						<div style="display: inline-block;" v-for="(item,index) in scope.row.goodsItem" :key="index">
							<el-tag style="margin: 5px">
								{{ item.customCode }} <span v-if="item.acceptCount>0" style="color: #67c23a;">已验</span>
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button icon="el-icon-view" type="text" @click="toogleExpand(scope.row)">查看条码</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				detail:{},
				tableData:[]
			};
		},
		mounted() {
			this.getDetail();
		},
		methods: {
			// 提交
			getDetail() {
				let params = {
					orderId:this.$route.query.id
				}
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_Url3 + 'api/Warehouse/InOrder/detail', params).then((res) => {
					loading.close();
					if (res.code == 0) {
						this.detail = res.data;
						this.tableData = this.sumGoods(this.detail.inOrderItems);
					}
				});
			},
			sumGoods(arry) {
				let sumData = [];
			
				arry.forEach(item => {
					let index = sumData.findIndex((ele) => {
						return item.goodsId == ele.goodsId && item.skus == ele.skus
					})
			
					if (index == -1) {
						sumData.push({
							goodsId: item.goodsId,
							goodsName: item.goodsName,
							count: item.count,
							acceptCount: item.acceptCount,
							skus: item.skus,
							skuValue: item.skuValue,
							unit: item.unit,
							goodsItem: [item],
						})
					} else {
						sumData[index].acceptCount += item.acceptCount;
						sumData[index].count += item.count;
						sumData[index].goodsItem.push(item);
					}
				})
				return sumData
			},
			toogleExpand(row) {
				let $table = this.$refs.table;
				this.tableData.map((item) => {
					if (row.skus != item.skus) {
						$table.toggleRowExpansion(item, false);
					}
				});
				$table.toggleRowExpansion(row);
			},
		},
	};
</script>
<style lang="scss">
	.page-add {
		.wrapper {
			.tit {
				font-size: 16px;
				margin-bottom: 28px;
				background-color: #f5f5f5;
				height: 40px;
				line-height: 40px;
				border-radius: 3px;

				.name {
					margin-left: 20px;
				}

				.day {
					color: #666;
				}
			}
		}
	}

	.row-expand-cove .el-table__expand-icon {
		display: none;
	}

	.el-table .sort-caret.descending {
		border-top-color: #000;
	}

	.el-table .sort-caret.ascending {
		border-bottom-color: #000;
	}
</style>
